module.exports = __webpack_public_path__ + "img/b7.e759b19c.jpg";